import React from "react";
import styles from "./feel-in-crowd.module.css";
import { Page } from "../../../components/page/page";
import { ContinueButton } from "../../../../../components/continue-button/continue-button";

const FeelInCrowdPage = () => {
  const buttonStyles = {
    backgroundColor: "#ffffff",
    color: "#6B3663",
  };
  return (
    <div className={styles.page}>
      <Page
        title={[
          "A ",
          <span>witch</span>,
          " in a crowd might feel a mix of heightened awareness, detachment, or overwhelm, as she navigates the collective energy and emotions around her",
        ]}
        hideSteps="true"
        hideContinueButton="true"
      >
        <ContinueButton
          link="../storm"
          buttonStyles={buttonStyles}
        ></ContinueButton>
      </Page>
    </div>
  );
};

export { FeelInCrowdPage };
